/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type BucketData = {
  bucket: string;
  prefix?: string | null | undefined;
  importFileMetadata?: boolean | undefined;
};

/** @internal */
export const BucketData$inboundSchema: z.ZodType<
  BucketData,
  z.ZodTypeDef,
  unknown
> = z.object({
  bucket: z.string(),
  prefix: z.nullable(z.string()).optional(),
  import_file_metadata: z.boolean().default(false),
}).transform((v) => {
  return remap$(v, {
    "import_file_metadata": "importFileMetadata",
  });
});
/** @internal */
export type BucketData$Outbound = {
  bucket: string;
  prefix?: string | null | undefined;
  import_file_metadata: boolean;
};

/** @internal */
export const BucketData$outboundSchema: z.ZodType<
  BucketData$Outbound,
  z.ZodTypeDef,
  BucketData
> = z.object({
  bucket: z.string(),
  prefix: z.nullable(z.string()).optional(),
  importFileMetadata: z.boolean().default(false),
}).transform((v) => {
  return remap$(v, {
    importFileMetadata: "import_file_metadata",
  });
});

export function bucketDataToJSON(bucketData: BucketData): string {
  return JSON.stringify(BucketData$outboundSchema.parse(bucketData));
}
export function bucketDataFromJSON(
  jsonString: string,
): SafeParseResult<BucketData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BucketData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BucketData' from JSON`,
  );
}
